export const fetchObject = async (blobClient, offset, size) => {
    const downloadResponse = await blobClient.download(offset, size);
    const downloaded = await downloadResponse.blobBody;
    const arrayBuffer = await downloaded.arrayBuffer();
    return new Uint8Array(arrayBuffer);
};
